import { useCallback } from 'react';
import { queryApi } from 'src/api/queryApi';
import toast from 'react-hot-toast';

const useUpdateQueryStatus = (queryID, userID) => {
  const updateStatus = useCallback(
    async (status) => {
      try {
        const response = await queryApi.updateQuery(queryID, status, userID);

        if (response.status === 'Query Updated') {
          toast.success(`Query updated to ${status}`);
        } else {
          toast.error(`Failed to update query: ${response.status}`);
        }

        return response.status === 'Query Updated';
      } catch (error) {
        toast.error('Error updating query status:', error);
        return false;
      }
    },
    [queryID, userID]
  );

  return { updateStatus };
};

export default useUpdateQueryStatus;
